import CharacterSpritesheet from "../sprite/CharacterSpritesheet";

export default class CharacterClass {
    /**
     * @param {CharacterSpritesheet} characterSpritesheet 
     */
    constructor(characterSpritesheet) {
        /**
         * @type {CharacterSpritesheet}
         */
        this.characterSpritesheet = characterSpritesheet;
    }

    /**
     * @param {number} characterAction See CharacterAction.
     * @param {number} characterActionStart Timestamp of start of action.
     * @returns {Sprite}
     */
    getSprite(characterAction, characterActionStart) {
        const spriteAnimation = this.characterSpritesheet.getSpriteAnimation(characterAction);
        if (!spriteAnimation) {
            return null;
        }

        return spriteAnimation.getSpriteAsOf(Date.now(), characterActionStart);
    }
}